import legalEntitySearchWithGeo from '~/packages/legalEntity/search/legalEntitySearchWithGeo.query'
import legalEntitySearchOnly from '~/packages/legalEntity/search/legalEntitySearchOnly.query'
import { maskNumbers, masks } from '~/prix/utils/types/mask'

export function legalEntitySearchWithGeoQueryFactory({
  hasUserRoles,
  userGeoState,
}: {
  hasUserRoles: boolean
  userGeoState: { items: any[] }
}) {
  return (input: string) =>
    legalEntitySearchWithGeo(input, hasUserRoles ? userGeoState.items[0] : undefined)
}

export function legalEntitySearchOnlyQueryFactory({
  hasUserRoles,
  userGeoState,
}: {
  hasUserRoles: boolean
  userGeoState: { items: any[] }
}) {
  return (input: string) =>
    legalEntitySearchOnly(input, hasUserRoles ? userGeoState.items[0] : undefined)
}

export function formatLegalEntitySearchItem(legalEntitySearchItem: any) {
  const { tradeName, corporateName, subtitle } = legalEntitySearchItem

  const cnpj = subtitle?.toString().substring(0, 14)
  const location = subtitle?.toString().substring(17)
  const formatedSubtitle = `${cnpj ? `${maskNumbers(cnpj, masks.cnpj)}` : ''}, ${location}`

  const uniqueTradeNameChars = [...new Set(tradeName?.toString().split(''))]
  const charBlackList = [`'`, '#', '*', 'x', 'X', '-', '.', '?', '@', '/', ':']
  const hasTrashTradeName =
    uniqueTradeNameChars.length === 1 &&
    charBlackList.some(
      wildChar =>
        wildChar ===
        (typeof uniqueTradeNameChars[0] === 'string' ? uniqueTradeNameChars[0].trim() : ''),
    )

  const formatedTradeCorporateName = `${
    tradeName && !hasTrashTradeName && tradeName !== corporateName ? `${tradeName} | ` : ''
  }${corporateName || ''}`

  return {
    ...legalEntitySearchItem,
    tradeName: formatedTradeCorporateName || 'Desconhecido',
    subtitle: formatedSubtitle,
  }
}
